import { FC } from "react";
import { useHeadAdaBalance } from "@/hooks/useHeadAdaBalance";

export const TvlBanner: FC = () => {
  const { formatted } = useHeadAdaBalance();

  if (!formatted) return null;

  return (
    <div className="flex items-center justify-center gap-2 py-1.5 text-xs text-sr-neutral-500">
      <span>TVL:</span>
      <span className="text-sr-lemon-muted font-medium tabular-nums">
        {formatted} ADA
      </span>
    </div>
  );
};
